import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import CPF from 'gerador-validador-cpf';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Creators as AuthActions } from 'store/ducks/auth';

import { Validate } from 'common';
import { Panel, Form, Loading, Icon } from 'components';

class Login extends Component {
  state = {
    form: {
      username: '',
      password: '',
    },
    errors: {},
  };

  handleChangeInput = e => {
    const { form, errors } = this.state;
    const { name, value } = e.target;
    this.setState({ form: { ...form, [name]: value } });

    Object.keys(errors).length && this.handleValidate();
  };

  handleChangeUsername = e => {
    const { form, errors } = this.state;
    const { value } = e.target

    this.setState({ form: { ...form, username: value } });

    Object.keys(errors).length && this.handleValidate();
  };

  handleValidate = () => {
    const { form } = this.state;

    const rules = {
      username: {
        required: true,
        email: true,
      },

      password: {
        required: true,
        length: {
          min: 6,
        },
      },
    };

    const validate = Validate(form, rules);
    this.setState({ errors: validate.errors });

    return validate.valid;
  };

  handleSubmit = e => {
    e.preventDefault();

    if (!this.handleValidate()) return null;

    const { form } = this.state;

    this.props.loginRequest({
      username: form.username,
      password: form.password,
    });
  };

  render() {
    const { form, errors } = this.state;
    const { login } = this.props;

    return (
      <Fragment>
        <Panel>
          <h4 className="text-uppercase font-bold mb-0 text-center">Login</h4>
          <h5 className="mb-0 text-muted text-center">Conecte-se no Painel</h5>
          <Form className="form-horizontal m-t-20 p-20" onSubmit={this.handleSubmit}>
            <Form.Group>
              <Form.Input
                name="username"
                placeholder="E-mail"
                value={form.username}
                onChange={this.handleChangeUsername}
                errors={errors.username}
                focus={1}
              />
            </Form.Group>

            <Form.Group>
              <Form.Input
                type="password"
                name="password"
                placeholder="Senha"
                value={form.password}
                onChange={this.handleChangeInput}
                errors={errors.password}
              />
            </Form.Group>

            <Form.Group className="m-t-40">
              <div className="row align-items-center">
                <div className="col-6">
                  {/* <Link to="/register" className="text-primary">
                    Criar Conta
                  </Link> */}
                </div>

                <div className="col-6">
                  <Form.Button className="btn btn-custom btn-block" type="submit" disabled={login.loading}>
                    {login.loading ? <Loading type="btn" size="small" text="Conectando..." /> : 'Conectar'}
                  </Form.Button>
                </div>
              </div>
            </Form.Group>
          </Form>
        </Panel>

        <div className="text-center">
          <Link to="/recover-password" className="text-muted">
            <Icon name="lock" className="m-r-10" />
            Esqueci minha senha
          </Link>
        </div>
      </Fragment>
    );
  }
}

const mapState = state => ({
  login: state.auth.login,
});

const mapActions = dispatch => bindActionCreators(AuthActions, dispatch);

export default connect(
  mapState,
  mapActions,
)(Login);



// WEBPACK FOOTER //
// ./src/pages/Auth/Login/index.js